import IQPlatform from './IQPlatform';

export default IQPlatform;